import React from 'react';
const SvgOdt = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...props}>
      <path fill="#FFF" d="M39 44H9V4h21l9 9z" />
      <path fill="#949494" d="M30 3H8v42h32V13L30 3zm0 1.5l8.5 8.5H30V4.5zM39 44H9V4h20v10h10v30z" />
      <path
        fill="#0078D7"
        d="M20.52 7l-.76 8.946c-.039.418-.059.693-.059.825 0 .211.037.373.111.484a.86.86 0 00.38.34c.16.075.43.112.808.112l-.081.293h-3.94l.082-.293h.17c.319 0 .58-.074.781-.223.143-.1.253-.266.332-.5.054-.163.106-.549.155-1.157l.118-1.364h-2.862l-1.018 1.483c-.231.333-.376.572-.435.718a1.091 1.091 0 00-.089.408c0 .17.064.315.192.436.128.122.34.188.634.199l-.08.293H12l.081-.293c.364-.016.685-.147.963-.393.278-.246.692-.77 1.243-1.574L20.262 7h.258zm-1.46 2.641l-2.9 4.243h2.516l.384-4.243zM12 20h24v1H12z"
      />
      <path
        fill="#C8C8C8"
        d="M12 23h12v1H12zM12 26h12v1H12zM12 29h12v1H12zM12 32h24v1H12zM12 35h24v1H12zM12 38h24v1H12z"
      />
      <path fill="#69AFE5" d="M23 17h13v1H23zM23 14h3v1h-3zM26 23h10v7H26z" />
      <linearGradient id="odt_svg__a" gradientUnits="userSpaceOnUse" x1={4.587} y1={5.864} x2={38.489} y2={46.268}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#odt_svg__a)" d="M40 13L30 3H8v42h32V13z" />
      <linearGradient id="odt_svg__b" gradientUnits="userSpaceOnUse" x1={34} y1={16.906} x2={34} y2={14.088}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.281} stopColor="#7f7f7f" stopOpacity={0.028} />
        <stop offset={0.45} stopColor="#777" stopOpacity={0.045} />
        <stop offset={0.59} stopColor="#696969" stopOpacity={0.059} />
        <stop offset={0.713} stopColor="#545454" stopOpacity={0.071} />
        <stop offset={0.826} stopColor="#3a3a3a" stopOpacity={0.083} />
        <stop offset={0.929} stopColor="#1a1a1a" stopOpacity={0.093} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#odt_svg__b)" d="M29 14h10v3H29z" />
      <linearGradient id="odt_svg__c" gradientUnits="userSpaceOnUse" x1={28.92} y1={19.08} x2={37.48} y2={10.52}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.854} stopColor="#fff" stopOpacity={0.213} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.25} />
      </linearGradient>
      <path fill="url(#odt_svg__c)" d="M8 3v1h21v10h10v31h1V13L30 3z" />
    </svg>
  );
});
export default SvgOdt;
SvgOdt.iconName = 'odt';
SvgOdt.displayName = 'SvgOdt';
